import { settings } from './IndustriesConfig';
import { StyledIndustries } from './Industries.styled';
import Carousel from '../../Carousel/Carousel';
import IndustriesCard from './IndustriesCard';

/**
 * Renders the Industries section displaying a carousel of industries with their details.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array<string|Object>} props.renderIndustriesData - An array of industries' data including titles, images, headings, and details.
 * @returns {JSX.Element} - The rendered Industries section.
 */

const Industries = (props) => {
  return (
    <>
      <StyledIndustries id='Industries' data-testid='industries-test'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <h3 className='title'>{props.data.title}</h3>
            </div>
            <Carousel config={settings}>
              {props.data.industriesDetail.map((data, index) => {
                return (
                  <IndustriesCard
                    image={data.image}
                    heading={data.heading}
                    detail={data.detail.map((detailView) => detailView)}
                    key={index}
                  />
                );
              })}
            </Carousel>
          </div>
          <div id='WhyChoose'></div>
        </div>
      </StyledIndustries>
    </>
  );
};

export default Industries;
